// extracted by mini-css-extract-plugin
export default {"overlay":"custom-popup_overlay__Jv547","popup":"custom-popup_popup__KSJgG","close":"custom-popup_close__MMNrV","content":"custom-popup_content__ZwlMs"};